/* CloudFunds – Theme-Skript ohne externe Abhängigkeiten.
   Header, Suche mit Vorschlägen, seitlicher Warenkorb (Shopify Ajax API + Section Rendering API),
   Variantenwahl, Galerie mit Zoom, Kaufleiste, Produktempfehlungen, Filter. Texte: snippets/theme-config.liquid */
(function () {
  'use strict';

  var CF = window.CF || {};
  var R = CF.routes || {};
  var S = CF.strings || {};
  var doc = document;
  var root = doc.documentElement;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motionOK() { return !reduceMQ.matches && root.classList.contains('cf-anim'); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function debounce(fn, ms) {
    var t;
    return function () { var a = arguments, self = this; clearTimeout(t); t = setTimeout(function () { fn.apply(self, a); }, ms); };
  }
  function CartError(message) { this.message = message; }

  /* ---------- Scrollsperre für offene Fenster ---------- */
  var locks = 0;
  function lock() { locks += 1; root.classList.add('is-locked'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) root.classList.remove('is-locked'); }

  /* ---------- Dialoge (Warenkorb, Filter, Suche, Zoom) ---------- */
  var Dialog = {
    bind: function (d) {
      if (!d || d._cfBound) return;
      d._cfBound = true;
      d.addEventListener('cancel', function (e) { e.preventDefault(); Dialog.close(d); });
      d.addEventListener('click', function (e) { if (e.target === d) Dialog.close(d); });
      d.addEventListener('close', function () { Dialog.release(d); });
    },
    open: function (d, opener) {
      if (!d || d.open) return;
      Dialog.bind(d);
      d._opener = opener || doc.activeElement;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      if (!d._locked) { d._locked = true; lock(); }
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    },
    close: function (d) {
      if (!d || !d.open || d._closing) return;
      d._closing = true;
      d.classList.remove('is-open');
      var panel = d.querySelector('.drawer__panel');
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        d._closing = false;
        if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
        Dialog.release(d);
        var o = d._opener;
        d._opener = null;
        if (o && o.focus && doc.contains(o)) o.focus({ preventScroll: true });
      }
      if (!panel || !motionOK()) { finish(); return; }
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 480);
    },
    release: function (d) {
      d.classList.remove('is-open');
      if (d._locked) { d._locked = false; unlock(); }
    }
  };

  /* ---------- Header ---------- */
  function initHeader() {
    var hdr = $('[data-header]');
    if (!hdr || hdr._cf) return;
    hdr._cf = true;
    var wrap = hdr.closest('.shopify-section') || hdr;
    var mode = hdr.getAttribute('data-sticky') || 'up';
    var menu = $('[data-mobile-menu]', hdr);
    var dds = $$('[data-dropdown]', hdr);
    wrap.classList.toggle('is-static', mode === 'none');

    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY);
      wrap.classList.toggle('is-scrolled', y > 2);
      if (mode === 'up') {
        var busy = (menu && menu.open) || dds.some(function (d) { return d.open; }) || root.classList.contains('is-locked');
        var hidden = wrap.classList.contains('is-hidden');
        if (y > lastY + 6 && y > 160 && !busy) hidden = true;
        else if (y < lastY - 6 || y < 80) hidden = false;
        wrap.classList.toggle('is-hidden', hidden);
        root.classList.toggle('hdr-hidden', hidden);
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    hdr.addEventListener('focusin', function () { wrap.classList.remove('is-hidden'); root.classList.remove('hdr-hidden'); });
    update();

    dds.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (dd.open) dds.forEach(function (o) { if (o !== dd) o.open = false; });
      });
    });
    doc.addEventListener('click', function (e) {
      dds.forEach(function (dd) { if (dd.open && !dd.contains(e.target)) dd.open = false; });
    });

    if (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) {
          wrap.classList.remove('is-hidden');
          root.classList.remove('hdr-hidden');
          var r = hdr.getBoundingClientRect();
          menu.style.setProperty('--menu-top', Math.max(0, Math.round(r.bottom)) + 'px');
          if (!menu._locked) { menu._locked = true; lock(); }
        } else if (menu._locked) {
          menu._locked = false;
          unlock();
        }
      });
      var mq = window.matchMedia('(min-width: 990px)');
      var onMq = function () { if (mq.matches && menu.open) menu.open = false; };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    }

    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dds.forEach(function (dd) {
        if (dd.open) { dd.open = false; var s = $('summary', dd); if (s) s.focus(); }
      });
      if (menu && menu.open) { menu.open = false; var ms = $('summary', menu); if (ms) ms.focus(); }
    });
  }

  /* ---------- Suche mit Vorschlägen ---------- */
  function initSearch() {
    var dlg = $('[data-search-dialog]');
    if (!dlg || dlg._cf) return;
    dlg._cf = true;
    Dialog.bind(dlg);
    var input = $('[data-search-input]', dlg);
    var results = $('[data-search-results]', dlg);

    doc.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-search-open]');
      if (opener) {
        e.preventDefault();
        var current = $('[data-search-dialog]');
        Dialog.open(current, opener);
        var field = $('[data-search-input]', current);
        if (field) field.focus();
        return;
      }
      var closer = e.target.closest('[data-search-close]');
      if (closer) Dialog.close(closer.closest('dialog'));
    });

    if (!CF.predictive || !R.predictive || !input || !results) return;
    var ctrl = null;
    var run = debounce(function () {
      var q = input.value.trim();
      if (ctrl) ctrl.abort();
      if (q.length < 2) { results.innerHTML = ''; return; }
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = R.predictive + '?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product%2Ccollection%2Cpage%2Carticle&resources%5Blimit%5D=6' +
        '&resources%5Blimit_scope%5D=each&section_id=predictive-search';
      results.setAttribute('aria-busy', 'true');
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
        .then(function (html) {
          if (input.value.trim() !== q) return;
          var el = parseHTML(html).querySelector('[data-predictive]');
          results.innerHTML = el ? el.outerHTML : '';
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') results.innerHTML = ''; })
        .then(function () { results.removeAttribute('aria-busy'); });
    }, 220);
    input.addEventListener('input', run);
  }

  /* ---------- Warenkorb ---------- */
  var Cart = {
    drawer: null,
    timers: {},

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      if (this.drawer) Dialog.bind(this.drawer);
      doc.addEventListener('click', this.onClick.bind(this));
      doc.addEventListener('change', this.onChange.bind(this));
      doc.addEventListener('submit', this.onSubmit.bind(this));
      window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
    },

    useDrawer: function () {
      return !!this.drawer && CF.cartType !== 'page' && !doc.body.classList.contains('tpl-cart');
    },

    open: function (opener) { if (this.drawer) Dialog.open(this.drawer, opener); },

    onClick: function (e) {
      var t = e.target;
      var opener = t.closest('[data-cart-open]');
      if (opener) {
        if (this.useDrawer()) { e.preventDefault(); this.open(opener); }
        return;
      }
      if (t.closest('[data-cart-close]')) { e.preventDefault(); Dialog.close(this.drawer); return; }

      var step = t.closest('[data-qty-step]');
      if (step) {
        var box = step.closest('.qty');
        var input = box && $('[data-qty-input]', box);
        if (!input) return;
        var inCart = !!input.closest('[data-cart-form]');
        var min = inCart ? 0 : 1;
        var next = Math.max(min, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-qty-step')));
        input.value = next;
        if (inCart) this.queue(input.closest('[data-line]'), next);
        return;
      }

      var rm = t.closest('[data-line-remove]');
      if (rm) {
        var line = rm.closest('[data-line]');
        if (line) { e.preventDefault(); this.change(line, 0); }
      }
    },

    onChange: function (e) {
      var t = e.target;
      if (t.matches('[data-qty-input]')) {
        if (t.closest('[data-cart-form]')) {
          var v = parseInt(t.value, 10);
          this.queue(t.closest('[data-line]'), isNaN(v) || v < 0 ? 0 : v, 0);
        } else if (!(parseInt(t.value, 10) > 0)) {
          t.value = 1;
        }
      } else if (t.matches('[data-cart-note]')) {
        this.saveNote(t.value);
      }
    },

    onSubmit: function (e) {
      var form = e.target;
      if (form.matches('[data-product-form]')) {
        e.preventDefault();
        this.add(form);
      } else if (form.matches('[data-cart-form]')) {
        e.preventDefault();
        var active = doc.activeElement;
        if (active && active.matches('[data-qty-input]')) this.queue(active.closest('[data-line]'), parseInt(active.value, 10) || 0, 0);
      }
    },

    sectionIds: function () {
      var ids = ['cart-drawer'];
      $$('[data-cart-section]').forEach(function (el) {
        var id = el.getAttribute('data-cart-section');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    },

    fetchSections: function () {
      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(this.sectionIds().join(',')), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : {}; })
        .catch(function () { return {}; });
    },

    refresh: function () { return this.fetchSections().then(this.render.bind(this)); },

    render: function (sections) {
      var self = this;
      if (!sections) return this.refresh();
      var count = null;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var fresh = parseHTML(html).querySelector('[data-cart-content]');
        if (!fresh) return;
        var target = id === 'cart-drawer'
          ? (self.drawer && $('[data-cart-content]', self.drawer))
          : $('[data-cart-section="' + id + '"]');
        if (!target) return;
        var active = doc.activeElement;
        var hadFocus = active && target.contains(active);
        var lineEl = hadFocus && active.closest('[data-line]');
        var sel = null;
        if (lineEl) {
          if (active.matches('[data-qty-input]')) sel = '[data-qty-input]';
          else if (active.matches('[data-qty-step]')) sel = '[data-qty-step="' + active.getAttribute('data-qty-step') + '"]';
        }
        var node = doc.importNode(fresh, true);
        target.replaceWith(node);
        if (hadFocus) {
          var again = lineEl && sel && node.querySelector('[data-line="' + lineEl.getAttribute('data-line') + '"] ' + sel);
          var fallback = node.querySelector('[data-cart-close], a, button, input');
          (again || fallback || node).focus({ preventScroll: true });
        }
        count = parseInt(node.getAttribute('data-count'), 10);
      });
      if (count !== null && !isNaN(count)) this.setCount(count);
      return Promise.resolve();
    },

    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    },

    showError: function (message) {
      if (!message) return;
      $$('[data-cart-error]').forEach(function (el) { el.textContent = message; el.hidden = false; });
    },

    queue: function (lineEl, qty, delay) {
      if (!lineEl) return;
      var key = lineEl.getAttribute('data-key') || lineEl.getAttribute('data-line');
      var self = this;
      clearTimeout(this.timers[key]);
      this.timers[key] = setTimeout(function () { self.change(lineEl, qty); }, delay === undefined ? 350 : delay);
    },

    change: function (lineEl, qty) {
      var self = this;
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      var key = lineEl.getAttribute('data-key');
      var wanted = Number(qty);
      $$('[data-cart-content]').forEach(function (c) { c.classList.add('is-busy'); });
      var message = '';
      return fetch(R.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: wanted, sections: this.sectionIds(), sections_url: location.pathname })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          var data = r.data || {};
          if (!r.ok || data.status) {
            message = data.description || data.message || S.error;
            return self.refresh();
          }
          if (key && wanted > 0 && Array.isArray(data.items)) {
            var item = data.items.filter(function (i) { return i.key === key; })[0];
            if (item && item.quantity < wanted) message = String(S.quantityLimited || '').replace('[n]', item.quantity);
          }
          if (typeof data.item_count === 'number') self.setCount(data.item_count);
          return self.render(data.sections);
        })
        .catch(function () { message = S.error; })
        .then(function () {
          $$('[data-cart-content]').forEach(function (c) { c.classList.remove('is-busy'); });
          self.showError(message);
        });
    },

    saveNote: debounce(function (value) {
      if (!R.cartUpdate) return;
      fetch(R.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      }).catch(function () {});
    }, 400),

    add: function (form) {
      var self = this;
      var btn = $('[data-add]', form);
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      var productEl = form.closest('[data-product]');
      var product = productEl && productEl._cf;
      var errEl = $('[data-product-error]', form);
      var label = $('[data-add-label]', btn) || btn;
      var sbar = productEl && $('[data-sticky-bar]', productEl);
      var sbarBtn = sbar && $('[data-sbar-add]', sbar);
      var sbarErr = sbar && $('[data-sbar-error]', sbar);
      [errEl, sbarErr].forEach(function (el) { if (el) { el.hidden = true; el.textContent = ''; } });

      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      label.textContent = S.adding;
      if (sbarBtn) { sbarBtn.disabled = true; sbarBtn.textContent = S.adding; }

      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && !(parseInt(qtyInput.value, 10) > 0)) qtyInput.value = 1;
      var body = new FormData(form);
      body.append('sections', this.sectionIds().join(','));
      body.append('sections_url', location.pathname);

      function done() {
        btn.removeAttribute('aria-busy');
        if (product) product.syncButtons();
        else { btn.disabled = false; label.textContent = S.addToCart; }
      }

      fetch(R.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok || data.status) throw new CartError(data.description || data.message || S.error);
            return data;
          });
        })
        .then(function (data) {
          if (!self.useDrawer()) { window.location.href = R.cart; return null; }
          return self.render(data.sections).then(function () { done(); self.open(btn); });
        })
        .catch(function (err) {
          var msg = err instanceof CartError ? err.message : S.error;
          if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
          if (sbarErr && sbar.classList.contains('is-visible')) { sbarErr.textContent = msg; sbarErr.hidden = false; }
          if (err instanceof CartError) self.refresh();
          done();
        });
    }
  };

  /* ---------- Galerie + Zoom ---------- */
  function Gallery(el) {
    this.el = el;
    if (!el) return;
    this.track = $('[data-gallery-track]', el);
    this.slides = this.track ? $$('.gal__slide', this.track) : [];
    this.thumbList = $('[data-gallery-thumbs]', el);
    this.thumbs = $$('[data-thumb]', el);
    this.prevBtn = $('[data-gallery-prev]', el);
    this.nextBtn = $('[data-gallery-next]', el);
    this.index = 0;
    var self = this;
    if (this.track && this.slides.length > 1) {
      this.track.addEventListener('scroll', function () {
        if (self.raf) return;
        self.raf = requestAnimationFrame(function () { self.raf = null; self.sync(); });
      }, { passive: true });
      this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.goTo(t.getAttribute('data-thumb')); }); });
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.goToIndex(self.index - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.goToIndex(self.index + 1); });
    }
    this.initZoom();
  }
  Gallery.prototype.sync = function () {
    var base = this.slides[0].offsetLeft;
    var x = this.track.scrollLeft;
    var best = 0;
    var dist = Infinity;
    this.slides.forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft - base - x);
      if (d < dist) { dist = d; best = i; }
    });
    if (best !== this.index) { this.index = best; this.mark(); }
  };
  Gallery.prototype.mark = function () {
    var i = this.index;
    var id = this.slides[i] && this.slides[i].getAttribute('data-media-id');
    var behavior = motionOK() ? 'smooth' : 'auto';
    var list = this.thumbList;
    this.thumbs.forEach(function (t) {
      var on = t.getAttribute('data-thumb') === id;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on && list) {
        var lr = list.getBoundingClientRect();
        var tr = t.getBoundingClientRect();
        if (tr.left < lr.left || tr.right > lr.right) {
          list.scrollBy({ left: (tr.left + tr.width / 2) - (lr.left + lr.width / 2), behavior: behavior });
        }
      }
    });
    if (this.prevBtn) this.prevBtn.disabled = i <= 0;
    if (this.nextBtn) this.nextBtn.disabled = i >= this.slides.length - 1;
    this.slides.forEach(function (s, n) {
      if (n === i) return;
      $$('video', s).forEach(function (v) { if (!v.paused) v.pause(); });
    });
  };
  Gallery.prototype.goToIndex = function (i) {
    if (!this.track || !this.slides.length) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    var s = this.slides[i];
    this.track.scrollTo({ left: s.offsetLeft - this.slides[0].offsetLeft, behavior: motionOK() ? 'smooth' : 'auto' });
    this.index = i;
    this.mark();
  };
  Gallery.prototype.goTo = function (mediaId) {
    var i = -1;
    this.slides.forEach(function (s, n) { if (s.getAttribute('data-media-id') === String(mediaId)) i = n; });
    if (i >= 0 && i !== this.index) this.goToIndex(i);
  };
  Gallery.prototype.initZoom = function () {
    var dlg = $('[data-zoom-dialog]', this.el);
    if (!dlg) return;
    Dialog.bind(dlg);
    var ztrack = $('[data-zoom-track]', dlg);
    var buttons = $$('[data-zoom-open]', this.el);
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    function zslides() { return $$('.zoom__slide', ztrack); }
    function build() {
      if (ztrack.childElementCount) return;
      buttons.forEach(function (b) {
        var li = doc.createElement('li');
        li.className = 'zoom__slide';
        var img = doc.createElement('img');
        var src = b.querySelector('img');
        img.src = b.getAttribute('data-zoom-src');
        img.alt = src ? src.alt : '';
        img.decoding = 'async';
        li.appendChild(img);
        ztrack.appendChild(li);
      });
    }
    function current() {
      var x = ztrack.scrollLeft;
      var w = ztrack.clientWidth || 1;
      return Math.round(x / w);
    }
    function show(i, smooth) {
      var all = zslides();
      i = Math.max(0, Math.min(all.length - 1, i));
      all.forEach(function (s) { s.classList.remove('is-zoomed'); });
      ztrack.scrollTo({ left: i * ztrack.clientWidth, behavior: smooth && motionOK() ? 'smooth' : 'auto' });
    }
    function origin(e, slide) {
      var img = slide.querySelector('img');
      var r = slide.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    }
    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        build();
        Dialog.open(dlg, b);
        requestAnimationFrame(function () { show(i, false); });
      });
    });
    ztrack.addEventListener('click', function (e) {
      var slide = e.target.closest('.zoom__slide');
      if (!slide || !fine.matches || e.target.tagName !== 'IMG') return;
      var on = slide.classList.toggle('is-zoomed');
      if (on) origin(e, slide);
    });
    ztrack.addEventListener('mousemove', function (e) {
      var slide = e.target.closest('.zoom__slide.is-zoomed');
      if (slide) origin(e, slide);
    });
    ztrack.addEventListener('scroll', debounce(function () {
      var i = current();
      zslides().forEach(function (s, n) { if (n !== i) s.classList.remove('is-zoomed'); });
    }, 120), { passive: true });
    var prev = $('[data-zoom-prev]', dlg);
    var next = $('[data-zoom-next]', dlg);
    var close = $('[data-zoom-close]', dlg);
    if (prev) prev.addEventListener('click', function () { show(current() - 1, true); });
    if (next) next.addEventListener('click', function () { show(current() + 1, true); });
    if (close) close.addEventListener('click', function () { Dialog.close(dlg); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current() - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current() + 1, true); }
    });
  };

  /* ---------- Produkt: Varianten, Preise, Verfügbarkeit, Kaufleiste ---------- */
  function Product(el) {
    this.el = el;
    el._cf = this;
    var json = $('[data-variants-json]', el);
    try { this.variants = json ? JSON.parse(json.textContent) : []; } catch (e) { this.variants = []; }
    this.picker = $('[data-variant-picker]', el);
    this.form = $('[data-product-form]', el);
    this.idInput = this.form && $('[data-variant-id]', this.form);
    this.addBtn = this.form && $('[data-add]', this.form);
    this.addLabel = this.addBtn && $('[data-add-label]', this.addBtn);
    this.dyn = $('[data-dynamic-checkout]', el);
    this.sbar = $('[data-sticky-bar]', el);
    var id = this.idInput ? String(this.idInput.value) : '';
    this.current = this.variants.filter(function (v) { return String(v.id) === id; })[0] || null;
    this.gallery = new Gallery($('[data-gallery]', el));
    var self = this;
    if (this.picker) {
      this.picker.addEventListener('change', function () { self.onOptionChange(); });
      this.mark(this.selected());
    }
    this.initSticky();
  }
  Product.prototype.fieldsets = function () { return this.picker ? $$('.vpick__opt', this.picker) : []; };
  Product.prototype.selected = function () {
    return this.fieldsets().map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
  };
  Product.prototype.onOptionChange = function () {
    var sel = this.selected();
    this.fieldsets().forEach(function (fs, i) {
      var out = $('[data-option-chosen]', fs);
      if (out) out.textContent = sel[i] || '';
    });
    this.current = this.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
    this.mark(sel);
    this.update(this.current);
  };
  Product.prototype.mark = function (sel) {
    var variants = this.variants;
    this.fieldsets().forEach(function (fs, i) {
      $$('[data-option-input]', fs).forEach(function (input) {
        var ok = variants.some(function (v) {
          return v.available && v.options[i] === input.value && v.options.every(function (o, j) { return j === i || o === sel[j]; });
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    });
  };
  Product.prototype.update = function (v) {
    var el = this.el;
    if (v && this.idInput) {
      this.idInput.value = v.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (v && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) { /* ignorieren */ }
    }
    var price = $('[data-price]', el);
    if (price && v) {
      var sale = !!v.compare;
      var now = $('[data-price-now]', price);
      var was = $('[data-price-was]', price);
      var lab = $('[data-price-label]', price);
      var unit = $('[data-price-unit]', price);
      if (now) now.textContent = v.price;
      price.classList.toggle('is-sale', sale);
      if (was) { was.hidden = !sale; var wv = $('[data-price-was-value]', was); if (wv) wv.textContent = v.compare || ''; }
      if (lab) lab.textContent = sale ? S.salePrice : S.regularPrice;
      if (unit) { unit.hidden = !v.unit; var uv = $('[data-price-unit-value]', unit); if (uv) uv.textContent = v.unit || ''; }
    }
    var av = $('[data-availability]', el);
    if (av) {
      var txt = $('[data-availability-text]', av);
      av.classList.toggle('is-out', !v || !v.available);
      av.classList.toggle('is-back', !!(v && v.available && v.backorder));
      if (txt) txt.textContent = !v ? S.unavailable : (!v.available ? S.soldOut : (v.backorder ? S.backorder : S.available));
    }
    ['sku', 'barcode'].forEach(function (k) {
      var row = $('[data-spec="' + k + '"]', el);
      if (!row) return;
      var val = v && v[k];
      row.hidden = !val;
      var dd = $('[data-spec-value]', row);
      if (dd) dd.textContent = val || '';
    });
    if (this.sbar && v) {
      var sp = $('[data-sbar-price]', this.sbar);
      var st = $('[data-sbar-variant]', this.sbar);
      if (sp) sp.textContent = v.price;
      if (st) st.textContent = v.title;
    }
    var err = $('[data-product-error]', el);
    if (err) { err.hidden = true; err.textContent = ''; }
    this.syncButtons();
    if (v && v.media && this.gallery) this.gallery.goTo(v.media);
  };
  Product.prototype.syncButtons = function () {
    var v = this.current;
    var ok = !!(v && v.available);
    var text = !v ? S.unavailable : (v.available ? S.addToCart : S.soldOut);
    if (this.addBtn && this.addBtn.getAttribute('aria-busy') !== 'true') {
      this.addBtn.disabled = !ok;
      if (this.addLabel) this.addLabel.textContent = text;
    }
    if (this.dyn) this.dyn.classList.toggle('is-hidden', !ok);
    var sb = this.sbar && $('[data-sbar-add]', this.sbar);
    if (sb) { sb.disabled = !ok; sb.textContent = text; }
  };
  Product.prototype.initSticky = function () {
    var bar = this.sbar;
    var buy = $('[data-buy]', this.el);
    var form = this.form;
    if (!bar) return;
    if (!buy || !form || !('IntersectionObserver' in window)) { bar.remove(); return; }
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      if (!show) { var e = $('[data-sbar-error]', bar); if (e) e.hidden = true; }
    });
    io.observe(buy);
    var btn = $('[data-sbar-add]', bar);
    if (btn) {
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  };

  /* ---------- Produktempfehlungen ---------- */
  function initRecs(scope) {
    $$('[data-recs]', scope).forEach(function (el) {
      if (el._cf || !el.getAttribute('data-url')) return;
      el._cf = true;
      if (el.querySelector('.grid')) return;
      function load() {
        fetch(el.getAttribute('data-url'))
          .then(function (res) { return res.ok ? res.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var fresh = parseHTML(html).querySelector('[data-recs]');
            if (fresh && fresh.querySelector('.grid')) el.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(el);
      } else {
        load();
      }
    });
  }

  /* ---------- Filter und Sortierung ---------- */
  function initFacets() {
    doc.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-sort-select]');
      if (!sel || !sel.form) return;
      if (typeof sel.form.requestSubmit === 'function') sel.form.requestSubmit();
      else sel.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
    doc.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-filter-open]');
      if (opener) {
        var wrap = opener.closest('[data-facets]');
        var dlg = wrap && $('[data-filter-dialog]', wrap);
        if (dlg) Dialog.open(dlg, opener);
        return;
      }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) Dialog.close(closer.closest('dialog'));
    });
    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-filter-form], [data-sort-form]')) return;
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      var action = form.getAttribute('action') || window.location.pathname;
      var query = params.toString();
      window.location.assign(query ? action + '?' + query : action);
    });
  }

  /* ---------- Start ---------- */
  function initScope(scope) {
    $$('[data-product]', scope).forEach(function (el) { if (!el._cf) new Product(el); });
    initRecs(scope);
  }

  function start() {
    initHeader();
    initSearch();
    Cart.init();
    initFacets();
    initScope(doc);
    doc.addEventListener('shopify:section:load', function (e) {
      initHeader();
      initSearch();
      initScope(e.target);
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})();
